export default {
  "FACILITIES_APP_VIEW": "FACILITIES_APP_VIEW",
  "APP_COMMERCE_VIEW": "APP_COMMERCE_VIEW",
  "APP_PWA_STANDALONE_ACCESS": "APP_PWA_STANDALONE_ACCESS"
}